import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import { Text } from "@components/General/Texts"
import designSystem from "@styles/designSystem"
import { useLocation } from 'react-router-dom';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { useValidateNumberViewModel } from '../view-models/ValidateNumberScreenViewModel';
import { TextInput } from '@components/General/TextInput';
import { NormalButton } from '@components/General/Button';
import { MobileWrapperScreen } from './MobileWrapperScreen';
import { useEffect } from 'react';

export const MobileValidateNumberScreen: React.FC = () => {
    const {
        loading,
        name,
        phone,
        company,
        code,
        codeError,
        setLoading,
        setCode,
        handleSubmit,
        viewDidAppear,
    } = useValidateNumberViewModel();

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once

    return (
        <MobileWrapperScreen>
            <VerticalContainer gap={designSystem.gapNone}>
                <H2Title text={"Validar Número".localized()}/>
                <Subtitle text={`Hola %s, vamos a validar tu número de teléfono`.localized(name)}/>
            </VerticalContainer>
            <Text text={"Escribí el código exactamente como aparece, te lo enviamos por **WhatsApp** al %s".localized(phone)} markdown={true}/>
            <TextInput
                label=""
                placeholder=""
                onChange={(e) => {setCode(e)}}
                onEnterPress={() => { handleSubmit() }}
                value={code}
                error={codeError}
            />
            <VerticalContainer alignment={'center'}>
                <NormalButton 
                    text={"Siguiente".localized()}
                    width={"100%"}
                    onClick={() => {
                        handleSubmit()
                    }} 
                    loading={loading}
                />
            </VerticalContainer>
        </MobileWrapperScreen>
    )    
}